import React, { PropsWithChildren } from 'react';
import { MediaLibProvider } from './toolympus/components/medialib';
import { DictionariesProvider } from './toolympus/hooks/useDictionaries';
import { DefaultUser } from './toolympus/userContext/UserContext';
import { UserSettingsProvider } from './toolympus/components/Settings/UserSettingsContext';
import { PluggableDocumentationProvider } from './toolympus/components/Documentation';
import { ActionsConfigProvider } from './toolympus/components/Actions/ActionsConfigProvider';
import { ApiConfgurationProvider } from './toolympus/components/ApiConfguration';

interface Props {
  
}

const isAdmin = (u: DefaultUser | null | undefined) => u?.roles?.includes("admin") || u?.roles?.includes("superadmin") || false;


export const ProvidersInternal = (props: PropsWithChildren<Props>) => {
  return (
    <MediaLibProvider
            apiPath="/api/media"
            spaceId="cms"
            getFilepath={mf => `/media/${mf.space_id}/${mf.filename}`}>
      <DictionariesProvider apiPath="/api/settings/dictionaries">
        <UserSettingsProvider apiPath="/api/admin-settings" canUpdateGlobal={isAdmin} >
          <PluggableDocumentationProvider apiPath="/api/documentation" canManage={isAdmin}>
            <ApiConfgurationProvider actionsApiPath="/api/actions">
              <ActionsConfigProvider>
                {props.children}
              </ActionsConfigProvider>
            </ApiConfgurationProvider>
          </PluggableDocumentationProvider>
        </UserSettingsProvider>
      </DictionariesProvider>    
    </MediaLibProvider>      
  );
}
